import { Resources } from 'constants/resources';

import { useStagedDelete } from 'hooks/useStagedDelete';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { queryClient } from 'providers/queryClient';
import { CancelButton } from 'shared/mui/Buttons';
import { DeleteStageDialog } from 'shared/mui/Dialogs/DeleteStageDialog/DeleteStageDialog';
import { DeleteStageDialogDenyReason } from 'shared/mui/Dialogs/DeleteStageDialog/DeleteStageDialogDenyReason';
import { Referral } from 'types/embedded/referral';

type CompaniesDeleteDialogProps = {
  record?: Referral;
  open: boolean;
  onClose: () => void;
  onSuccess?: () => void;
};

export const ReferralsDeleteDialog: React.FC<CompaniesDeleteDialogProps> = ({
  record,
  open,
  onClose,
  onSuccess,
}) => {
  const translate = useTypedTranslate();

  const { deleteOneRecord, denyDeleteReason, stage } = useStagedDelete({
    record,
    onSuccess: async () => {
      onSuccess?.();

      await queryClient.invalidateQueries({ queryKey: [Resources.Referrals] });
      onClose();
    },
  });

  return (
    <DeleteStageDialog
      deleteOneRecord={deleteOneRecord}
      details={translate('app.referrals.deleteDetails', { name: record?.name })}
      onClose={onClose}
      open={open}
      stage={stage}
      title={translate('app.referrals.deleteTitle')}
    >
      <DeleteStageDialogDenyReason reason={denyDeleteReason}>
        <CancelButton onClick={onClose} sx={{ marginLeft: 'auto' }} variant="outlined" />
      </DeleteStageDialogDenyReason>
    </DeleteStageDialog>
  );
};
